import { create } from 'zustand';

interface UIState {
  filterPanelOpen: boolean;
  toggleFilterPanel: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  filterPanelOpen: false,
  toggleFilterPanel: () => set((state) => ({ filterPanelOpen: !state.filterPanelOpen })),
}));
